function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { firebase } from './../../../utils/firebase/firebase';

import * as roomsActions from './../roomsActions';

import ChatroomSelector from './../ChatroomSelector/ChatroomSelector';

export var ChatroomsList = function (_Component) {
    _inherits(ChatroomsList, _Component);

    function ChatroomsList() {
        var _temp, _this, _ret;

        _classCallCheck(this, ChatroomsList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.extractMessagesData = function (timestamps, messages) {
            var lastMessage = 0;
            var count = {
                unreadMessages: 0,
                reportUnview: 0,
                messages: 0
            };

            if (typeof messages === 'undefined') {
                return { counter: count, lastUpdate: lastMessage };
            }

            for (var messageId in messages) {
                count.messages++;
                messages[messageId].createdAt > timestamps && count.unreadMessages++;
                lastMessage = messages[messageId].createdAt > lastMessage ? messages[messageId].createdAt : lastMessage;

                if (typeof messages[messageId].report !== 'undefined') {
                    for (var reportId in messages[messageId].report) {
                        messages[messageId].report[reportId].createdAt > timestamps && count.reportUnview++;
                    }
                }
            }

            return { counter: count, lastUpdate: lastMessage };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ChatroomsList.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var ref = firebase.firebaseApp.database().ref('rooms');
        ref.on('child_added', function (snapshot) {
            var _snapshot$val = snapshot.val(),
                roomName = _snapshot$val.roomName,
                messages = _snapshot$val.messages,
                lastSeen = _snapshot$val.lastSeen,
                metaData = _snapshot$val.metaData;

            var userLastSeen = lastSeen.admin || false;
            var nbMessages = 0;
            var key = snapshot.key;
            _this2.props.dispatch(roomsActions.retrieveRooms(key, roomName, metaData, _this2.extractMessagesData(userLastSeen, messages)));
        });

        ref.on('child_changed', function (snapshot) {
            var key = snapshot.key;

            var _snapshot$val2 = snapshot.val(),
                messages = _snapshot$val2.messages,
                lastSeen = _snapshot$val2.lastSeen;

            var userLastSeen = lastSeen.admin || false;
            _this2.props.dispatch(roomsActions.reorderRooms(key, _this2.extractMessagesData(userLastSeen, messages)));
        });
    };

    ChatroomsList.prototype.componentWillUnmount = function componentWillUnmount() {
        firebase.firebaseApp.database().ref('rooms').off();
        this.props.dispatch(roomsActions.resetRoomsList());
    };

    ChatroomsList.prototype.render = function render() {
        var _this3 = this;

        var _props = this.props,
            rooms = _props.rooms,
            inUseChatroom = _props.inUseChatroom;

        return React.createElement(
            'ul',
            { className: 'rooms' },
            React.createElement('li', { className: 'hide', ref: function ref(el) {
                    _this3.el = el;
                } }),
            rooms.map(function (room, index) {
                return React.createElement(
                    'li',
                    { key: room.chatroomId },
                    React.createElement(ChatroomSelector, { chatroomName: room.chatroomName, room: room.chatroomId, reportUnview: room.counter.reportUnview }),
                    React.createElement(
                        'span',
                        { className: inUseChatroom === room.chatroomId ? "hide" : room.counter.unreadMessages ? "nbUnreadMessages" : "hide" },
                        room.counter.unreadMessages
                    )
                );
            })
        );
    };

    return ChatroomsList;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        rooms: state.rooms.rooms,
        inUseChatroom: state.chatroom.chatroomId,
        userId: state.auth.uid
    };
};

export default connect(mapStateToProps)(ChatroomsList);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Rooms/ChatroomsList/ChatroomsList.js
// module id = 227
// module chunks = 0